import { createSelector } from 'reselect';

import type { RootState } from 'state/types';

const getGoalsState = ({ goals }: RootState) => goals;

export const getCreatedByType = createSelector(getGoalsState, ({ createdByType }) => createdByType);
